import { render, staticRenderFns } from "./AIBotResponseFilter.vue?vue&type=template&id=3bbb20b2&scoped=true"
import script from "./AIBotResponseFilter.vue?vue&type=script&lang=js"
export * from "./AIBotResponseFilter.vue?vue&type=script&lang=js"
import style0 from "./AIBotResponseFilter.vue?vue&type=style&index=0&id=3bbb20b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb20b2",
  null
  
)

export default component.exports